import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import RequestBrief from '../components/common/RequestBrief';

// Unlisted public page for one card: the brief plus every file, for people
// outside the tracker. No login — the token in the URL is the credential.
const SharedRequest = () => {
  const { token } = useParams();
  const [request, setRequest] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(`/api/share/${token}`);
        if (!cancelled) setRequest(res.data);
      } catch (err) {
        if (!cancelled) setError(err.response?.data?.msg || 'This link is no longer active.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [token]);

  // Keep shared pages out of search results.
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => { document.head.removeChild(meta); };
  }, []);

  useEffect(() => {
    if (request?.title) document.title = request.title;
  }, [request]);

  const fileUrl = (id) => `${axios.defaults.baseURL || ''}/api/share/${token}/files/${id}`;
  const zipUrl = `${axios.defaults.baseURL || ''}/api/share/${token}/files.zip`;

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-950">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary-blue" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-950 px-4">
        <div className="text-center">
          <h1 className="text-2xl font-black text-gray-900 dark:text-gray-100">Link no longer active</h1>
          <p className="mt-2 text-gray-500">{error} Ask whoever sent it for a fresh link.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 py-10 px-4">
      <div className="max-w-3xl mx-auto">
        <RequestBrief request={request} fileUrl={fileUrl} zipUrl={zipUrl} />

        <p className="mt-6 text-center text-xs text-gray-400">
          Private link — please don't forward it outside your team.
        </p>
      </div>
    </div>
  );
};

export default SharedRequest;
